const CHUNK_LOAD_MESSAGE =
  /(?:Loading (?:CSS )?chunk\b.*\bfailed|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS)/i;

function readStringProperty(value: unknown, key: "message" | "name") {
  if (typeof value !== "object" || value === null || !(key in value)) {
    return "";
  }
  const property = (value as Record<string, unknown>)[key];
  return typeof property === "string" ? property : "";
}

/** Detect the browser-specific shapes used for stale or missing app chunks. */
export function isChunkLoadError(
  error: unknown,
  fallbackMessage = "",
): boolean {
  const name = readStringProperty(error, "name");
  const message =
    readStringProperty(error, "message") ||
    (typeof error === "string" ? error : fallbackMessage);

  return name === "ChunkLoadError" || CHUNK_LOAD_MESSAGE.test(message);
}
